module.exports = __webpack_public_path__ + "static/media/bg-dashboard.cf62384c.svg";